import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../components/ui/Card.js';
import { useAuth } from '../contexts/AuthContext.js';

export function Login() {
  const { state, login } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const returnTo = params.get('return_to') ?? '/';

  // Si ya está auth, redirigir a return_to (caso: user navega directo a /login)
  useEffect(() => {
    if (state.status === 'authenticated') {
      navigate(returnTo, { replace: true });
    }
  }, [state.status, returnTo, navigate]);

  if (state.status === 'authenticated') {
    return null;
  }

  return (
    <div className="max-w-md mx-auto py-12">
      <Card>
        <CardHeader>
          <CardTitle>Iniciar sesión</CardTitle>
        </CardHeader>
        <CardBody>
          <p className="mb-6">
            Inicia sesión con tu cuenta autorizada de <strong>Cloudflare Access</strong> para
            acceder a SISREP Distrital.
          </p>
          <Button variant="primary" size="lg" onClick={() => login(returnTo)} className="w-full">
            Iniciar sesión con CF Access
          </Button>
          {state.status === 'error' && (
            <p className="mt-4 text-sm text-red-600" role="alert">
              Error: {state.error}
            </p>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
